const glamor = require("glamor");
// Do not prefix any properties. The browsers we target do not need them.
glamor.plugins.remove(
  glamor.plugins.fns.find(pluginFn => pluginFn.name === "prefixes")
);
require("./renderApp");
